module.exports = __webpack_public_path__ + "static/media/spellcheck.09883f39.svg";